import axios from 'axios';

import interceptors from '@/api/interceptors';
import persisted from '@/helpers/modules/auth';

const client = axios.create({
  baseURL: persisted.environment,
});

client.interceptors.request.use(
  interceptors.request.success,
  interceptors.request.error,
);

client.interceptors.response.use(
  interceptors.response.success,
  interceptors.response.error,
);

export default client;
